import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppLayout from "layouts/app-layout";
// import AuthLayout from 'layouts/auth-layout';
import AppLocale from "lang";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from 'antd';
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from 'configs/AppConfig'
import useBodyClass from 'hooks/useBodyClass';
import LoginTwo from "./auth-views/authentication/login-1";
import RegisterTwo from "./auth-views/authentication/register-2/RegisterTwo";
import CompanyJobList from "./iframe/CompanyJobList";
import ForgotPassword from "./auth-views/authentication/forgot-password/ForgotPassword";
import ResetPassword from "./auth-views/authentication/reset-password/ResetPassword";
import EmailVerify from "./auth-views/authentication/email-verify";
// import PrivacyPolicy from "./app-views/privacy";
// function RouteInterceptor({ children, isAuthenticated, ...rest }) {
//   return (
//     <Route
//       {...rest}
//       render={({ location }) =>
//         isAuthenticated ? (
//           children
//         ) : (
//           <Redirect
//             to={{
//               pathname: AUTH_PREFIX_PATH,
//               state: { from: location }
//             }}
//           />
//         )
//       }
//     />
//   );
// }

export const Views = (props) => {
  const { locale, location, direction } = props;
  const currentAppLocale = AppLocale[locale];
  useBodyClass(`dir-${direction}`);
  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      messages={currentAppLocale.messages}>
      <ConfigProvider locale={currentAppLocale.antd} direction={direction}>
        <Switch>

          <Route exact path="/">
            <Redirect to={APP_PREFIX_PATH} />
          </Route>
          <Route path="/job-list/:key">
            <CompanyJobList/>
          </Route>
          <Route exact path={AUTH_PREFIX_PATH}>
            <LoginTwo allowRedirect={true}/>
          </Route>
          <Route path={`${AUTH_PREFIX_PATH}/register`}>
             <RegisterTwo/>
          </Route>
          <Route path={`${AUTH_PREFIX_PATH}/forgot-password`} >
            <ForgotPassword/>
          </Route>
          <Route path={`${AUTH_PREFIX_PATH}/reset-password/:token`} >
            <ResetPassword/>
          </Route>
          <Route path={`${AUTH_PREFIX_PATH}/verify-email/:token`} >
            <EmailVerify/>
          </Route>
          <Route path={APP_PREFIX_PATH}>
            <AppLayout direction={direction} location={location} />
          </Route>
          {/* <RouteInterceptor path={APP_PREFIX_PATH} isAuthenticated={token}>
            <AppLayout direction={direction} location={location} />
          </RouteInterceptor> */}
        </Switch>
      </ConfigProvider>
    </IntlProvider>
  )
}

const mapStateToProps = ({ theme, auth }) => {
  const { locale, direction } = theme;
  const { token } = auth;
  return { locale, token, direction }
};

export default withRouter(connect(mapStateToProps)(Views));